<template>
  <kst-section items-mode class="mt-5">
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="ItemID"
        :label="InvoiceItemCatalog.Name.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Details(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="InvoiceItemCatalog.Packaging.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="RequestedQuantity"
        :label="InvoiceItemCatalog.RequestedQuantity.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="InvoiceItemCatalog.SellPrice.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
        />
      </b-table-column>

      <template v-if="data.SpecialPriceCount > 0">
        <b-table-column
          v-slot="{ column, row }"
          cell-class="ks-col-price"
          field="SpecialPriceName"
          :label="InvoiceItemCatalog.SpecialPriceName.Label"
        >
          <kst-output field-only
            :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
          />
        </b-table-column>

        <b-table-column numeric
          v-slot="{ column, row }"
          cell-class="ks-col-price"
          field="SellPriceNetto"
          :label="InvoiceItemCatalog.SellPriceNetto.Label"
        >
          <kst-output box-off field-only
            :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
          />
        </b-table-column>
      </template>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Price"
        :label="InvoiceItemCatalog.Price.Label"
      >
        <kst-output box-off field-only
          :field="column.field" :data="row" :catalog="InvoiceItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import InvoiceItemCatalog from "../InvoiceItemCatalog.js";
import Model from "../InvoiceModel.js";

export default {
  props: {
    data: Object,
    items: Array
  },
  data: () => ({
    InvoiceItemCatalog: InvoiceItemCatalog,
    Model: Model
  })
}
</script>